import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { DMUSelectionService } from 'src/app/services/dmu-selection.service';

@Component({
  selector: 'app-multiple-select-ppopover',
  templateUrl: './multiple-select-ppopover.component.html',
  styleUrls: ['./multiple-select-ppopover.component.scss'],
})
export class MultipleSelectPpopoverComponent implements OnInit, AfterViewInit {
  options: any[] = [];
  selectedOptions: string[] = [];
  search: string = '';
  isSearch: boolean = true;
  labelSearch: string = 'Buscar';
  id: string = '';
  selectAll: boolean = false

  @Output() selectionChange = new EventEmitter<string[]>();
  constructor(
    private popoverController: PopoverController,
    private _selectionService: DMUSelectionService
  ) {
  }
  ngAfterViewInit(): void {}

  ngOnInit() {
    
    
   if(this.selectedOptions.length <= 0){
    this.selectAllItems()
   }else{
    this.options.forEach((option) => {
      // Verifica si el nombre de la opción está presente en this.selectedOptions
      if (this.selectedOptions.includes(option.name)) {
        // Si está presente, establece la propiedad selected en true
        option.selected = true;
      }
    });
   }
  }

  isChecked(option: string): boolean {
    return this.selectedOptions.includes(option);
  }

  closePopover() {
    this.popoverController.dismiss({
      selectedOptions: this.options
        .filter((option) => option.selected)
        .map((option) => option.name),
    });
  }

  validateMaxSelected() {
    return this.options.filter((label) => label.selected).length >= 20;
  }

  selectAllItems(){
    this.options.map((option) => option.selected = false)
    this.updateSelectedOptions()
  }

  showButton(){
    return this.options.filter((label) => label.selected).length > 0;
  }

  updateSelectedOptions() {
    if(this.id == 'dmu'){
      this._selectionService.updateSelectedOptions(
        this.options
          .filter((option) => option.selected)
          .map((option) => option.name)
      );
    }else if(this.id == 'series') {
      this._selectionService.updateSeries(
        this.options
          .filter((option) => option.selected)
          //.map((option) => option.id)
      );
    }
    
  }
}
